// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 임금대장 관리 페이지 스타일 */
.salary-management {
  min-height: calc(100vh - 80px);
  background-color: #f8f9fa;
}

.salary-layout {
  display: flex;
  height: calc(100vh - 80px);   /* 뷰포트에 고정 → 내부 스크롤만, 바깥(윈도우) 스크롤 제거 */
  min-height: 0;
  overflow: hidden;
}

.salary-management .company-sidebar {
  width: 350px;
  min-width: 350px;
  background: white;
  border-right: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  position: relative;
  transition: width 0.25s ease, min-width 0.25s ease;
}

.salary-management .company-sidebar .sidebar-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.salary-management .company-sidebar.folded {
  width: 48px;
  min-width: 48px;
}

.salary-management .company-sidebar.folded .sidebar-content {
  display: none;
}

.sidebar-fold-toggle {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.05);
  color: #495057;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease, color 0.2s ease;
  z-index: 2;
}

.sidebar-fold-toggle:hover {
  background: rgba(0, 123, 255, 0.12);
  color: #007bff;
}

.sidebar-fold-icon {
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1;
}

.salary-management .company-sidebar.folded .sidebar-fold-toggle {
  right: 50%;
  transform: translateX(50%);
  background: #f8f9fa;
  border: 1px solid #e1e5e9;
}

.salary-management .company-sidebar.folded .sidebar-fold-toggle:hover {
  background: #e9ecef;
}

.sidebar-fold-label {
  position: absolute;
  top: 44px;
  left: 50%;
  transform: translateX(-50%);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 0.8rem;
  font-weight: 600;
  color: #495057;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

/* 접기 단추: 펼친 상태는 신규 기업 등록 아래에 사이드바 폭을 가득 채운 넓은 단추, 접은 상태는 세로 띠 전체가 단추 */
.sidebar-fold-toggle {
  position: static;
  flex: none;
  width: auto;
  height: 40px;
  margin: 0 1rem 1rem;
  gap: 6px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  background: #f1f3f5;
  color: #212529;
  font-size: 0.95rem;
  font-weight: 600;
}
.sidebar-fold-toggle::after { content: '기업검색 접기'; }
.sidebar-fold-toggle:hover { border-color: #007bff; }
.sidebar-fold-icon { font-size: 1.5rem; }
.salary-management .company-sidebar.folded .sidebar-fold-toggle {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  transform: none;
  align-items: flex-start;
  padding-top: 10px;
  border: none;
  border-radius: 0;
  background: #f8f9fa;
}
.salary-management .company-sidebar.folded .sidebar-fold-toggle::after { content: none; }
.salary-management .company-sidebar.folded .sidebar-fold-toggle:hover { background: #e7f1ff; }
.sidebar-fold-label { top: 52px; z-index: 3; pointer-events: none; }

.salary-content {
  flex: 1 1;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;
  min-height: 0;   /* flex 자식이 뷰포트 높이 안에서 바운드되도록(내부 스크롤 활성) */
}

.no-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.no-selection-content {
  text-align: center;
  padding: 3rem;
  max-width: 500px;
}

.no-selection-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
  opacity: 0.7;
}

.no-selection h3 {
  color: #495057;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.no-selection p {
  color: #6c757d;
  font-size: 1rem;
  margin: 0 0 2rem 0;
  line-height: 1.5;
}

.no-selection-features {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  text-wrap: pretty;
}

.feature-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  font-size: 1.5rem;
}

.feature-item span:last-child {
  font-size: 0.9rem;
  font-weight: 500;
  color: #495057;
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
  text-align: center;
}

.retry-btn {
  margin-top: 1rem;
  padding: 0.75rem 1.5rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.retry-btn:hover {
  background: #0056b3;
}

/* 반응형 디자인 */
@media (max-width: 1024px) {
  .salary-management .company-sidebar {
    width: 320px;
    min-width: 320px;
  }
  .salary-management .company-sidebar.folded {
    width: 48px;
    min-width: 48px;
  }
}

@media (max-width: 768px) {
  .salary-layout {
    flex-direction: column;
  }
  
  .salary-management .company-sidebar {
    width: 100%;
    height: 300px;
    border-right: none;
    border-bottom: 1px solid #e1e5e9;
  }
  
  .salary-content {
    min-height: calc(100vh - 380px);
  }
  
  .no-selection-content {
    padding: 2rem 1rem;
  }
  
  .no-selection-features {
    flex-direction: column;
    gap: 1rem;
  }
  
  .feature-item {
    flex-direction: row;
    justify-content: center;
    padding: 0.75rem 1rem;
  }
}

@media (max-width: 480px) {
  .salary-management .company-sidebar {
    height: 250px;
  }
  
  .salary-content {
    min-height: calc(100vh - 330px);
  }
  
  .no-selection-icon {
    font-size: 3rem;
  }
  
  .no-selection h3 {
    font-size: 1.25rem;
  }
  
  .no-selection p {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SalaryManagement.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B,IAAI,sCAAsC;EACpE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA,8BAA8B,kBAAkB,EAAE;AAClD,6BAA6B,qBAAqB,EAAE;AACpD,qBAAqB,iBAAiB,EAAE;AACxC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA,yEAAyE,aAAa,EAAE;AACxF,wEAAwE,mBAAmB,EAAE;AAC7F,sBAAsB,SAAS,EAAE,UAAU,EAAE,oBAAoB,EAAE;;AAEnE;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa,IAAI,0CAA0C;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* 임금대장 관리 페이지 스타일 */\r\n.salary-management {\r\n  min-height: calc(100vh - 80px);\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.salary-layout {\r\n  display: flex;\r\n  height: calc(100vh - 80px);   /* 뷰포트에 고정 → 내부 스크롤만, 바깥(윈도우) 스크롤 제거 */\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.salary-management .company-sidebar {\r\n  width: 350px;\r\n  min-width: 350px;\r\n  background: white;\r\n  border-right: 1px solid #e1e5e9;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);\r\n  position: relative;\r\n  transition: width 0.25s ease, min-width 0.25s ease;\r\n}\r\n\r\n.salary-management .company-sidebar .sidebar-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.salary-management .company-sidebar.folded {\r\n  width: 48px;\r\n  min-width: 48px;\r\n}\r\n\r\n.salary-management .company-sidebar.folded .sidebar-content {\r\n  display: none;\r\n}\r\n\r\n.sidebar-fold-toggle {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  width: 28px;\r\n  height: 28px;\r\n  padding: 0;\r\n  margin: 0;\r\n  border: none;\r\n  border-radius: 6px;\r\n  background: rgba(0, 0, 0, 0.05);\r\n  color: #495057;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.2s ease, color 0.2s ease;\r\n  z-index: 2;\r\n}\r\n\r\n.sidebar-fold-toggle:hover {\r\n  background: rgba(0, 123, 255, 0.12);\r\n  color: #007bff;\r\n}\r\n\r\n.sidebar-fold-icon {\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  line-height: 1;\r\n}\r\n\r\n.salary-management .company-sidebar.folded .sidebar-fold-toggle {\r\n  right: 50%;\r\n  transform: translateX(50%);\r\n  background: #f8f9fa;\r\n  border: 1px solid #e1e5e9;\r\n}\r\n\r\n.salary-management .company-sidebar.folded .sidebar-fold-toggle:hover {\r\n  background: #e9ecef;\r\n}\r\n\r\n.sidebar-fold-label {\r\n  position: absolute;\r\n  top: 44px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  writing-mode: vertical-rl;\r\n  text-orientation: mixed;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  letter-spacing: 0.05em;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* 접기 단추: 펼친 상태는 신규 기업 등록 아래에 사이드바 폭을 가득 채운 넓은 단추, 접은 상태는 세로 띠 전체가 단추 */\r\n.sidebar-fold-toggle {\r\n  position: static;\r\n  flex: none;\r\n  width: auto;\r\n  height: 40px;\r\n  margin: 0 1rem 1rem;\r\n  gap: 6px;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 8px;\r\n  background: #f1f3f5;\r\n  color: #212529;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n}\r\n.sidebar-fold-toggle::after { content: '기업검색 접기'; }\r\n.sidebar-fold-toggle:hover { border-color: #007bff; }\r\n.sidebar-fold-icon { font-size: 1.5rem; }\r\n.salary-management .company-sidebar.folded .sidebar-fold-toggle {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  transform: none;\r\n  align-items: flex-start;\r\n  padding-top: 10px;\r\n  border: none;\r\n  border-radius: 0;\r\n  background: #f8f9fa;\r\n}\r\n.salary-management .company-sidebar.folded .sidebar-fold-toggle::after { content: none; }\r\n.salary-management .company-sidebar.folded .sidebar-fold-toggle:hover { background: #e7f1ff; }\r\n.sidebar-fold-label { top: 52px; z-index: 3; pointer-events: none; }\r\n\r\n.salary-content {\r\n  flex: 1;\r\n  background: white;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  min-width: 0;\r\n  min-height: 0;   /* flex 자식이 뷰포트 높이 안에서 바운드되도록(내부 스크롤 활성) */\r\n}\r\n\r\n.no-selection {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\r\n}\r\n\r\n.no-selection-content {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  max-width: 500px;\r\n}\r\n\r\n.no-selection-icon {\r\n  font-size: 4rem;\r\n  margin-bottom: 1.5rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n.no-selection h3 {\r\n  color: #495057;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.no-selection p {\r\n  color: #6c757d;\r\n  font-size: 1rem;\r\n  margin: 0 0 2rem 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n.no-selection-features {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 2rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.feature-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 1rem;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  transition: all 0.2s ease;\r\n  text-wrap: pretty;\r\n}\r\n\r\n.feature-item:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.feature-icon {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.feature-item span:last-child {\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  color: #495057;\r\n}\r\n\r\n.error-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  padding: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.retry-btn {\r\n  margin-top: 1rem;\r\n  padding: 0.75rem 1.5rem;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.retry-btn:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 1024px) {\r\n  .salary-management .company-sidebar {\r\n    width: 320px;\r\n    min-width: 320px;\r\n  }\r\n  .salary-management .company-sidebar.folded {\r\n    width: 48px;\r\n    min-width: 48px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .salary-layout {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .salary-management .company-sidebar {\r\n    width: 100%;\r\n    height: 300px;\r\n    border-right: none;\r\n    border-bottom: 1px solid #e1e5e9;\r\n  }\r\n  \r\n  .salary-content {\r\n    min-height: calc(100vh - 380px);\r\n  }\r\n  \r\n  .no-selection-content {\r\n    padding: 2rem 1rem;\r\n  }\r\n  \r\n  .no-selection-features {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .feature-item {\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    padding: 0.75rem 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .salary-management .company-sidebar {\r\n    height: 250px;\r\n  }\r\n  \r\n  .salary-content {\r\n    min-height: calc(100vh - 330px);\r\n  }\r\n  \r\n  .no-selection-icon {\r\n    font-size: 3rem;\r\n  }\r\n  \r\n  .no-selection h3 {\r\n    font-size: 1.25rem;\r\n  }\r\n  \r\n  .no-selection p {\r\n    font-size: 0.9rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
